import React, { useEffect, useMemo, useState } from 'react';
import * as XLSX from 'xlsx';
import {
  Typography,
  Box,
  Fab,
  Dialog,
  Button,
  Grid,
  Tooltip,
  DialogTitle,
  IconButton,
} from '@mui/material';
import {
  getUserData,
  getUserProjects,
  getUserTasks,
} from '../../services/UserService';
import { getProjectById } from '../../services/ProjectService';
import { downloadUserTasks } from '../../services/UserService';
import { useDispatch, useSelector } from 'react-redux';
import './FilterTask/TransitionFilter.css';
import KeycloakService from '../../services/KeycloakService';
import '../../App.css';
import PaginationComponent from '../../components/Pagination/Pagination';
import AddIcon from '@mui/icons-material/Add';
import TaskCards from './TaskCards/TaskCards';
import TaskField from './TaskField';
import TaskFieldCopy from './TaskFieldCopy';
import { Container } from '@mui/system';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import BasicModal from '../../components/Modal/Modal';
import FilterDrawer from './FilterTask/FilterDrawer';
import { RESET_DATE_RANGE, SHOW_NOTIFICATION } from '../../constants';
import { NO_TASK, SET_DATE_RANGE, TASK_EDIT_CLOSE } from './TaskConstants';
import GenericFilterDrawer from '../../components/GenericFilter/GenericFilterDrawer';
import {
  resetFilterDataState,
  setFilterConfig,
} from '../../modules/filter/filterAction';
import { checkFilterIconVisibility } from '../../components/GenericFilter/FilterIconVisibilityCheck';
import {
  getExternalQuotaForUser,
  getClientOfficeQuotaForUser,
  getWorkTravelQuotaForUser,
} from '../../admin/Services/EmployeePrivilegesService';
import ExternalSummaryCard from './TaskCards/ExternalSummaryCard';
import { msToTime } from '../../utils/TimeConversionFunctions';
import { hoursToMilliseconds } from 'date-fns';
import {
  getConsolidatedTimings,
  getSummary,
} from '../../services/TimingService';
import { CLIENT_OFFICE } from './TaskConstants';

const hasCurrentMonthQuota = (allottedInMS, availedInMS) =>
  (allottedInMS || 0) > 0 || (availedInMS || 0) > 0;

const TasksComponent = (props) => {
  const [loader, setLoader] = React.useState(true);
  const currentUserId = KeycloakService.getUserDetail();
  const currentEmployeeId = KeycloakService.getEmployeeId();
  const [rows, setRows] = React.useState([]);
  const [prevProjects, setPrevProjects] = React.useState([]);
  const [userProjects, setUserProjects] = React.useState([]);
  const [allProjects, setAllProjects] = React.useState([]);
  const [options, setOptions] = useState({});
  const [selectedTaskData, setSelectedTaskData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const dateRangeState = useSelector((state) => state.dateRangeState);
  const [savedStartDate, setSavedStartDate] = React.useState(new Date());
  const [savedEndDate, setSavedEndDate] = React.useState(new Date());
  const dispatch = useDispatch();
  const [refresh, setRefresh] = React.useState(false);

  const filterState = useSelector((state) => state.filterState);

  const [monthlyQuotaAllotted, setMonthlyQuotaAllotted] = useState(0);
  const [monthlyQuotaAvailed, setMonthlyQuotaAvailed] = useState(0);

  const [monthlyQuotaAllottedInMS, setMonthlyQuotaAllottedInMS] = useState(0);
  const [monthlyQuotaAvailedInMS, setMonthlyQuotaAvailedInMS] = useState(0);
  const [clientOfficeMonthlyQuotaAllotted, setClientOfficeMonthlyQuotaAllotted] =
    useState(0);
  const [clientOfficeMonthlyQuotaAvailed, setClientOfficeMonthlyQuotaAvailed] =
    useState(0);
  const [
    clientOfficeMonthlyQuotaAllottedInMS,
    setClientOfficeMonthlyQuotaAllottedInMS,
  ] = useState(0);
  const [
    clientOfficeMonthlyQuotaAvailedInMS,
    setClientOfficeMonthlyQuotaAvailedInMS,
  ] = useState(0);
  const [clientOfficeQuotaDetails, setClientOfficeQuotaDetails] = useState();
  const [workTravelMonthlyQuotaAllotted, setWorkTravelMonthlyQuotaAllotted] =
    useState(0);
  const [workTravelMonthlyQuotaAvailed, setWorkTravelMonthlyQuotaAvailed] =
    useState(0);
  const [
    workTravelMonthlyQuotaAllottedInMS,
    setWorkTravelMonthlyQuotaAllottedInMS,
  ] = useState(0);
  const [
    workTravelMonthlyQuotaAvailedInMS,
    setWorkTravelMonthlyQuotaAvailedInMS,
  ] = useState(0);
  const [workTravelQuotaDetails, setWorkTravelQuotaDetails] = useState();
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const employeeId = currentUserId;
  const [quotaDetails, setQuotaDetails] = useState();

  const emptyFilterData = {
    taskTitle: '',
    taskType: '',
    projectName: '',
    startDate: '',
    endDate: '',
    appraisal: false,
  };

  const [pageSize, setPageSize] = React.useState(10);
  const [totalPage, setTotalPage] = React.useState();
  const [pageNo, setPageNo] = React.useState(0);
  const [page, setPage] = React.useState(1);

  const [open, setOpen] = React.useState(false);

  const msToHours = (duration) => {
    const hours = duration / (1000 * 60 * 60);
    const roundedHours = Math.round(hours * 10) / 10;
    return roundedHours;
  };

  const handleClose = () => {
    setOpen(false);
    dispatch({
      type: SET_DATE_RANGE,
      data: {
        ...dateRangeState,
        startDate: savedStartDate,
        endDate: savedEndDate,
      },
    });
    dispatch({
      type: TASK_EDIT_CLOSE,
    });
    setSelectedTaskData(() => {
      return {
        id: null,
        project: '',
        taskTitle: '',
        description: '',
      };
    });
  };

  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => {
      setSavedStartDate(dateRangeState.startDate);
      setSavedEndDate(dateRangeState.endDate);
    }, 200);
    dispatch({
      type: RESET_DATE_RANGE,
    });
  };
  const taskDataState = useSelector((state) => state.taskOperation);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefresh(!refresh);
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
  };

  const getTask = async () => {
    const userTasks = await getUserTasks(
      currentUserId,
      filterState,
      filterState.appraisal,
      pageSize,
      pageNo,
    );
    if (userTasks.isError == false) {
      if (userTasks.data.numberOfElements == 0) {
        setPageNo(0);
        setPage(1);
      }
      setTotalPage(userTasks.data.totalPages);
      getPreviousProjects(userTasks.data.content);
      setRows(userTasks.data.content);
      setLoader(false);
    }
    if (userTasks.status !== 200) {
      dipatchNotification(userTasks.type, userTasks.message);
    }
  };

  const getData = async () => {
    const today = new Date();
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    const endDate = today;

    const formattedStartDate = startDate.toLocaleDateString('en-CA');
    const formattedEndDate = endDate.toLocaleDateString('en-CA');

    const summaryData = await getSummary(
      formattedStartDate,
      formattedEndDate,
      currentUserId,
    );

    if (summaryData.isError === false) {
      const externalhrsavailed = summaryData?.data?.totalExternalHours || 0;
      setMonthlyQuotaAvailed(msToTime(externalhrsavailed));
      setMonthlyQuotaAvailedInMS(externalhrsavailed);
      const clientOfficeAvailed =
        summaryData?.data?.totalClientOfficeHours || 0;
      setClientOfficeMonthlyQuotaAvailed(msToTime(clientOfficeAvailed));
      setClientOfficeMonthlyQuotaAvailedInMS(clientOfficeAvailed);
      const workTravelAvailed = summaryData?.data?.totalWorkTravelHours || 0;
      setWorkTravelMonthlyQuotaAvailed(msToTime(workTravelAvailed));
      setWorkTravelMonthlyQuotaAvailedInMS(workTravelAvailed);
    }
  };

  useEffect(() => {
    if (rows.length) {
      getData();
    }
  }, [rows]);
  const getPreviousProjects = async (rowsTemp) => {
    let projectIds = rowsTemp.map((rowTemp) => {
      return rowTemp.projectId;
    });
    let setprojectIds = new Set(projectIds);
    let arrayProjects = Array.from(setprojectIds);
    let prevProjectData = [];
    for (const currProjectId of arrayProjects) {
      const user = userProjects.find((project) => project.id === currProjectId);
      if (!user) {
        let singleProject = await getProjectById(
          currProjectId,
          pageNo,
          pageSize,
        );
        prevProjectData.push(singleProject.data.content[0]);
      }
    }
    for (let i = 0; i < prevProjectData.length; i++) {
      prevProjectData[i].projectId = prevProjectData[i].id;
    }
    setPrevProjects(prevProjectData);
  };

  const getProjectsList = async () => {
    const projectData = await getUserProjects(
      currentUserId,
      '',
      '',
      '',
      'ACTIVE',
    );
    if (projectData.isError == false) {
      setUserProjects(projectData.data.content);
      setOptions({ ...options, project: projectData.data.content });
    }
    if (projectData.status !== 200) {
      dipatchNotification(projectData.type, projectData.message);
    }
  };

  const getTaskForEdit = (id) => {
    const currentSelectedTask = rows[id];
    setSelectedTaskData(currentSelectedTask);
    handleOpen();
  };

  const handleFilterIconClick = () => {
    setOpenDrawer(!openDrawer);
  };

  const filterConfiguration = {
    inputField: [
      [
        ['taskType', 'Task Type'],
        [
          ['EXTERNAL', 'External hours'],
          ['CLIENT_OFFICE', 'Client Office Hours'],
          ['WORK_TRAVEL', 'Work Travel Hours'],
        ],
      ],
    ],
    checkField: [['appraisal', 'Is Appraisable']],
    dropdownField: [['Search Project', 'project', 'projectName', 'projectId']],
  };

  const resetThings = () => {
    for (let arrayOfArrays of filterConfiguration.dropdownField) {
      setOptions({ ...options, [arrayOfArrays[1]]: [] });
    }
    dispatch(setFilterConfig(filterConfiguration));
    dispatch(resetFilterDataState());
    dispatch({
      type: RESET_DATE_RANGE,
    });
  };

  const [resetFilter, setResetFilter] = useState(false);

  const getEmployeeExtQuota = async () => {
    const [extResponse, clientResponse, workTravelResponse] = await Promise.all([
      getExternalQuotaForUser(employeeId, year),
      getClientOfficeQuotaForUser(employeeId, year),
      getWorkTravelQuotaForUser(employeeId, year),
    ]);
    setQuotaDetails(extResponse?.data?.data?.externalHoursQuota);
    setMonthlyQuotaAllotted(
      `${extResponse?.data?.data?.externalHoursQuota?.thisYear?.[month]} hrs 00 min` ||
        '0 min',
    );
    setMonthlyQuotaAllottedInMS(
      hoursToMilliseconds(
        extResponse?.data?.data?.externalHoursQuota?.thisYear?.[month] || 0,
      ),
    );
    setClientOfficeQuotaDetails(
      clientResponse?.data?.data?.clientOfficeHoursQuota,
    );
    setClientOfficeMonthlyQuotaAllotted(
      `${clientResponse?.data?.data?.clientOfficeHoursQuota?.thisYear?.[month]} hrs 00 min` ||
        '0 min',
    );
    setClientOfficeMonthlyQuotaAllottedInMS(
      hoursToMilliseconds(
        clientResponse?.data?.data?.clientOfficeHoursQuota?.thisYear?.[month] ||
          0,
      ),
    );
    setWorkTravelQuotaDetails(
      workTravelResponse?.data?.data?.workTravelHoursQuota,
    );
    setWorkTravelMonthlyQuotaAllotted(
      `${workTravelResponse?.data?.data?.workTravelHoursQuota?.thisYear?.[month]} hrs 00 min` ||
        '0 min',
    );
    setWorkTravelMonthlyQuotaAllottedInMS(
      hoursToMilliseconds(
        workTravelResponse?.data?.data?.workTravelHoursQuota?.thisYear?.[
          month
        ] || 0,
      ),
    );
  };

  useEffect(() => {
    resetThings();
    setResetFilter(true);
    getEmployeeExtQuota();
  }, []);

  useEffect(() => {
    let tmpRows = [...rows];
    for (let i = 0; i < rows.length; i++) {
      for (const project of allProjects) {
        if (project?.projectId === rows[i]?.projectId) {
          tmpRows[i].projectName = project.projectName;
          break;
        }
      }
    }
    setRows(tmpRows);
  }, [allProjects]);

  const temp = useMemo(() => {
    pageChange(null, 1);
  }, [filterState]);

  useEffect(() => {
    let projectsMap = new Map();
    for (let project of [...userProjects, ...prevProjects]) {
      projectsMap.set(project.projectId, project);
    }
    setAllProjects([...projectsMap.values()]);
  }, [userProjects, prevProjects]);

  useEffect(() => {
    if (resetFilter) {
      getTask();
      getProjectsList();
    }
  }, [pageNo, page, refresh, resetFilter]);

  // useEffect(() => {
  //   if (rows) {
  //     getPreviousProjects();
  //   }
  // }, [rows]);

  return (
    <>
      {!loader && (
        <Box className="main-content-overlay">
          {hasCurrentMonthQuota(monthlyQuotaAllottedInMS, monthlyQuotaAvailedInMS) && (
            <ExternalSummaryCard
              monthlyQuotaAllotted={monthlyQuotaAllotted}
              monthlyQuotaAvailed={monthlyQuotaAvailed}
              title="External Hours Quota"
            />
          )}
          {hasCurrentMonthQuota(
            clientOfficeMonthlyQuotaAllottedInMS,
            clientOfficeMonthlyQuotaAvailedInMS,
          ) && (
            <ExternalSummaryCard
              monthlyQuotaAllotted={clientOfficeMonthlyQuotaAllotted}
              monthlyQuotaAvailed={clientOfficeMonthlyQuotaAvailed}
              title="Client Office Hours Quota"
            />
          )}
          {hasCurrentMonthQuota(
            workTravelMonthlyQuotaAllottedInMS,
            workTravelMonthlyQuotaAvailedInMS,
          ) && (
            <ExternalSummaryCard
              monthlyQuotaAllotted={workTravelMonthlyQuotaAllotted}
              monthlyQuotaAvailed={workTravelMonthlyQuotaAvailed}
              title="Work Travel Hours Quota"
            />
          )}
          <Box className="main-content-div">
            <Grid
              container
              className="head-title-text"
              sx={{ alignItems: 'center' }}
            >
              <Grid item md={12}>
                <Grid
                  className="align-container-inline"
                  sx={{ alignItems: 'center', mr: 4, ml: 4 }}
                >
                  {checkFilterIconVisibility(
                    filterState,
                    emptyFilterData,
                    rows,
                  ) && (
                    <React.Fragment>
                      <GenericFilterDrawer options={options} />
                    </React.Fragment>
                  )}
                </Grid>
              </Grid>
            </Grid>

            {rows.length == 0 && loader == false ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '80vh',
                }}
              >
                <div>
                  <Typography>{NO_TASK}</Typography>
                </div>
              </div>
            ) : (
              <></>
            )}
            <Box>
              <Tooltip
                title={
                  <Typography sx={{ fontSize: '0.8rem' }}>Add Task</Typography>
                }
                placement="top"
              >
                <Fab
                  color="primary"
                  style={{
                    right: 40,
                    bottom: 50,
                    position: 'fixed',
                    zIndex: 1051,
                    // the zIndex of edit and delete buttons is 1050
                  }}
                  onClick={() => {
                    handleOpen();
                  }}
                >
                  <AddIcon />
                </Fab>
              </Tooltip>

              <Box
                sx={{
                  overflow: 'hidden',
                }}
              >
                {rows.map((item, index) => {
                  return (
                    <>
                      {rows.length != 0 ? (
                        <TaskCards
                          item={item}
                          rowId={index}
                          getTaskForEdit={getTaskForEdit}
                        />
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
              </Box>
              <Dialog open={open} fullWidth maxWidth="md" onClose={handleClose}>
                <TaskField
                  userProjects={allProjects}
                  handleClose={handleClose}
                  getTask={getTask}
                  editData={selectedTaskData}
                  setSelectedTaskData={setSelectedTaskData}
                  rows={rows}
                  setPage={setPage}
                  setPageNo={setPageNo}
                  monthlyQuotaAllottedInMS={monthlyQuotaAllottedInMS}
                  monthlyQuotaAvailedInMS={monthlyQuotaAvailedInMS}
                  clientOfficeMonthlyQuotaAllottedInMS={
                    clientOfficeMonthlyQuotaAllottedInMS
                  }
                  clientOfficeMonthlyQuotaAvailedInMS={
                    clientOfficeMonthlyQuotaAvailedInMS
                  }
                  workTravelMonthlyQuotaAllottedInMS={
                    workTravelMonthlyQuotaAllottedInMS
                  }
                  workTravelMonthlyQuotaAvailedInMS={
                    workTravelMonthlyQuotaAvailedInMS
                  }
                  quotaDetails={quotaDetails}
                  clientOfficeQuotaDetails={clientOfficeQuotaDetails}
                  workTravelQuotaDetails={workTravelQuotaDetails}
                ></TaskField>
              </Dialog>
              {rows.length ? (
                <Box className="page-holder ml-4" sx={{ padding: '8px' }}>
                  <PaginationComponent
                    count={totalPage}
                    page={page}
                    pageChange={pageChange}
                    pageSize={pageSize}
                    handlePageSizeChange={handlePageSizeChange}
                  />
                </Box>
              ) : (
                <></>
              )}
            </Box>
            <Box>
              {taskDataState.delete && (
                <BasicModal
                  getTask={getTask}
                  rows={rows}
                  setTotalPage={setTotalPage}
                  setPage={setPage}
                />
              )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TasksComponent;
